import Image from "next/legacy/image";
import Link from "next/link";
import classnames from "classnames";
import banner from "../public/img/about/banner.png";
import officalLink from "../public/img/about/offical-link.png";
import opensea from "../public/img/about/opensea.png";
import discord from "../public/img/about/discord.png";
import twitter from "../public/img/about/twitter.png";
import medium from "../public/img/about/medium.png";

import en01 from "../public/img/about/en/01.png";
import en02 from "../public/img/about/en/02.png";
import en03 from "../public/img/about/en/03.png";

import cn01 from "../public/img/about/cn/01.png";
import cn02 from "../public/img/about/cn/02.png";
import cn03 from "../public/img/about/cn/03.png";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { CHEERS_UP_DISCORD_URL } from "../constants";

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

export default function About() {
  const router = useRouter();

  const list = [
    { img: officalLink, link: "https://cryptonatty.io/cn/cheersup" },
    {
      img: opensea,
      link: "https://opensea.io/collection/cheers-up-period",
    },
    { img: discord, link: CHEERS_UP_DISCORD_URL },
    { img: twitter, link: "https://twitter.com/CryptoNatty_io" },
    { img: medium, link: "https://medium.com/@baselabs" },
  ];

  let img01 = en01;
  let img02 = en02;
  let img03 = en03;
  if (router.locale === "cn") {
    img01 = cn01;
    img02 = cn02;
    img03 = cn03;
  }

  return (
    <div>
      <style>
        {`
        body{
          background-color: black;
        }`}
      </style>
      <div>
        <Image src={banner} layout="responsive" />
      </div>
      <Image src={img01} layout="responsive" />

      <div className="relative">
        <Image src={img02} layout="responsive" />
        <Link
          href="https://twitter.com/CryptoNatty_io/status/1532557684653924386?s=19"
          passHref
          target="_blank"
        >
          <div
            className={classnames("absolute top-[20%] w-full h-[46%]", {
              // "bg-[red] opacity-20": true,
            })}
          ></div>
        </Link>
        <Link
          href="https://twitter.com/CryptoNatty_io/status/1532695095350546432"
          passHref
          target="_blank"
        >
          <div
            className={classnames("absolute top-[70%] w-full h-[14%]", {
              // "bg-[red] opacity-20": true,
            })}
          ></div>
        </Link>
      </div>

      <Image src={img03} layout="responsive" />

      <div className="px-[8.4375%] pb-[80px]">
        {list.map((item, i) => {
          return (
            <div className="mb-[24px]" key={i}>
              <Link href={item.link} passHref target="_blank">
                <Image src={item.img} layout="responsive" />
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
